import React, { Fragment, ReactNode } from 'react'
import { ColumnIntent, SelectFunc } from './additional'

export enum Align {
    LEFT = 'align-left',
    RIGHT = 'align-right',
    CENTER = 'align-center',
}

export interface ColumnProps<Item> {
    keyProp?: string | number,
    headerRenderer?: ReactNode,
    cellRenderer?: (data: Item, column: number, row: number) => ReactNode,
    // transformFunc?: TransformFunc<Item>,
    columnAlign?: Align,
    cellSelector?: SelectFunc<Item>,
    cellClass?: (item: Item) => string,
    visible?: boolean,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Column<Item>(props: ColumnProps<Item>): JSX.Element {
    return <Fragment/>
}

Column.defaultProps = {
    columnAlign: Align.LEFT,
    cellRenderer: () => undefined,
    cellSelector: () => ColumnIntent.NONE,
    cellClass: () => '',
    visible: true,
}
